import { SofaFormValidator } from '@sofology/sofologycomponents';
import { ValidateOperatorTypeDescription } from 'models';
import { isValidByOperator } from './formValidators';

export const booleanRequiredValidator = (errorMessage: string, getExternalValue: () => () => boolean, expectedExternalValue: boolean, operator: ValidateOperatorTypeDescription): SofaFormValidator<boolean> => (value: boolean) => {
    let externalValue = getExternalValue()();

    if (externalValue === null && value === null && operator === ValidateOperatorTypeDescription.EqualTo) {
        return Promise.resolve(null);
    }

    if (externalValue === null && value === null && operator !== ValidateOperatorTypeDescription.EqualTo) {
        return Promise.resolve(errorMessage);
    }

    let shouldBeValidated = externalValue === null ? false : isValidByOperator<boolean>(externalValue, expectedExternalValue, operator);

    let required = shouldBeValidated ? (value === null || isValidByOperator<boolean>(value, expectedExternalValue, operator)) : false;

    return Promise.resolve(required ? errorMessage : null);
};
